export function loadConfig() {
  return require('../env/' + process.env.REACT_APP_BUILD_ENV + '_config');
}
